import { useState } from "react";

export default function TagInput({ label, placeholder, tags, setTags }) {
  const [input, setInput] = useState("");

  const addTag = () => {
    const trimmed = input.trim();
    if (trimmed && !tags.includes(trimmed)) {
      setTags([...tags, trimmed]);
      setInput("");
    }
  };

  const handleKey = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      addTag();
    }
  };

  const removeTag = (idx) => {
    setTags(tags.filter((_, i) => i !== idx));
  };

  return (
    <div className="mb-4">
      <label className="block font-semibold mb-1">{label}</label>
      <div className="flex flex-wrap gap-2 p-2 border rounded bg-white min-h-[48px]">
        {tags.map((tag, idx) => (
          <span
            key={idx}
            className="flex items-center bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-sm"
          >
            {tag}
            <button
              onClick={() => removeTag(idx)}
              className="ml-1 text-blue-500 hover:text-red-600"
            >
              ×
            </button>
          </span>
        ))}
        <input
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKey}
          placeholder={placeholder}
          className="flex-1 min-w-[120px] p-1 outline-none"
        />
      </div>
    </div>
  );
}
